import classnames from 'classnames';
import styles from './Text.module.less';
export var useTextStyles = function useTextStyles(_ref) {
  var overflowWrap = _ref.overflowWrap,
      size = _ref.size;
  return {
    className: classnames([overflowWrap !== undefined && styles["text-overflow-wrap-".concat(overflowWrap)], size !== undefined && styles["text-".concat(size)]])
  };
};